import React from 'react';
import { Field } from 'formik';
import {
	StyledInput,
	StyledFieldWrapper,
	StyledLabel,
	StyledErrorMessage
} from '../../base/forms/formik';

const FormField = ({
	field = {},
	handleActive = () => { },
	setActive = () => { },
	values = [],
	required = false,
	active = false
}) => {
	return (
		<StyledFieldWrapper key={field.id}>
			<StyledLabel
				active={active}
				htmlFor={field.fieldName}>
				<span>{field.labelName}</span>
				{ required && <span> *</span> }
			</StyledLabel>
			<Field
				name={field.fieldName}>
				{(fieldProps) => {
					const { onBlur, ...props } = fieldProps.field;
					return (
						<StyledInput
							type="text"
							onFocus={setActive.bind(null, field.fieldName)}
							onBlur={(e) => {
								handleActive(field.fieldName, values);
								onBlur(e);
							}}
							readOnly={field.readOnly}
							active={active}
							{...props} />
					);
				}}
			</Field>
			<StyledErrorMessage name={field.fieldName} component="div" />
		</StyledFieldWrapper>
	);
};

export default FormField;
